'use client'

import { useEffect } from 'react'

export default function OverflowDebug() {
  useEffect(() => {
    // Check if debug mode is enabled
    const urlParams = new URLSearchParams(window.location.search)
    const debugEnabled = urlParams.get('debugOverflow') === 'true'

    if (!debugEnabled) return

    // Set data attribute for CSS
    document.documentElement.setAttribute('data-debug-overflow', 'true')

    // Import and run overflow scanner
    import('@/app/utils/overflowDebug').then(({ initOverflowDebug }) => {
      initOverflowDebug()
    })

    return () => {
      document.documentElement.removeAttribute('data-debug-overflow')
    }
  }, [])

  return null
}

